import { render, staticRenderFns } from "./FormSubCuenta.vue?vue&type=template&id=39da4806&scoped=true"
import script from "./FormSubCuenta.vue?vue&type=script&lang=js"
export * from "./FormSubCuenta.vue?vue&type=script&lang=js"
import style0 from "./FormSubCuenta.vue?vue&type=style&index=0&id=39da4806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da4806",
  null
  
)

export default component.exports